<div class="container" style="padding-left: 30px;">
    <h1 style="color: #002b5c; text-transform: none; padding-top: 20px;">Reservation settings</h1>
    <mat-form-field class="d-flex" appearance="fill" [formGroup]="dateForm" required>
        <mat-label>Select a Date</mat-label>
        <input matInput readonly [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <!-- <mat-form-field appearance="fill">
      <mat-label>Select Day</mat-label>
      <mat-select [(value)]="currentDay" (selectionChange)="changeDay($event)" disableOptionCentering>
        <mat-option *ngFor="let day of dayList" [value]="day.day">
          {{day.title}}
        </mat-option>
      </mat-select>
</mat-form-field> -->
  
    <dual-list [sort]="keepSorted" [(source)]="allTimes" key="id" [display]="display" [filter]="filter"
      [(destination)]="confirmed" height="350px" [format]="format" [disabled]="disabled"
      (activeListChange)="setActiveList($event)"></dual-list>
    <button type="button" [disabled]="saving" class="btn btn-primary pull-right" style="margin-top: 20px;"
      (click)="save()">
      <div class="d-flex">
        <span style="padding-right: 10px">Save</span>
        <mat-spinner *ngIf="saving" [diameter]="15"></mat-spinner>
      </div>
    </button>
    <h3 *ngIf="successfullySaved" style="color: #002b5c;">Successfully updated time slots</h3>
    <h3 *ngIf="errorOnSave" style="color: #002b5c;">Failed to update time slots, contact admin</h3>
  </div>